export class Filter{
  constructor(public idCard: number, public keyWord: string, public categoryId: number, public stateId: number) {
  }
}
